/**
 * components/globalErrorBoundary.tsx — last-resort boundary so a render crash
 * anywhere in the tree shows a readable fallback instead of a blank screen.
 */
import React from 'react';
import { View, ScrollView } from 'react-native';
import { LightColors as C, FontSize as FS, FontWeight as FW } from '../theme/theme';
import { Txt } from './ui';

interface State {
  error: Error | null;
}

export default class GlobalErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <View style={{ flex: 1, backgroundColor: C.paper, padding: 32 }}>
        <Txt size={FS.lg} weight={FW.semibold} color={C.danger} style={{ marginBottom: 12 }}>
          Something went wrong
        </Txt>
        <ScrollView>
          <Txt mono size={FS.sm} color={C.ink2}>
            {error.message}
            {'\n\n'}
            {error.stack}
          </Txt>
        </ScrollView>
      </View>
    );
  }
}
